import type { GuardianRelationshipStatus } from "../../../../types/guardianTypes";
import type { GigRequestStatus } from "../../../../types/gigTypes";
import { gigRequestStatusLabel } from "../../../../types/types";
import { formatDate, formatShortDateTime, formatShortDateTimeInGigTimeZone } from "../../../../utils/DateUtils";
import { formatTeenGigCompensation } from "../../../../utils/GigCompensationUtils";

export const requestedGigStatusLabel: Record<GigRequestStatus, string> = gigRequestStatusLabel;

export const requestedGigStatusPillClassName: Record<GigRequestStatus, string> = {
  GUARDIAN_PENDING: "bg-amber-100 text-amber-900 border-amber-200",
  GUARDIAN_REJECTED: "bg-rose-100 text-rose-900 border-rose-200",
  POSTER_PENDING: "bg-myteengig-secondary text-myteengig-text-primary border-myteengig-border",
  POSTER_SELECTED_PENDING_CREW: "bg-sky-100 text-sky-900 border-sky-200",
  PAYOUT_SETUP_PENDING: "bg-amber-100 text-amber-900 border-amber-200",
  FUNDING_PENDING: "bg-emerald-100 text-emerald-900 border-emerald-200",
  POSTER_ACCEPTED: "bg-emerald-100 text-emerald-900 border-emerald-200",
  FILLED_BY_OTHER_TEEN: "bg-sky-100 text-sky-900 border-sky-200",
  POSTER_REJECTED: "bg-rose-100 text-rose-900 border-rose-200",
  EXPIRED: "bg-amber-100 text-amber-900 border-amber-200",
  WITHDRAWN: "bg-slate-100 text-slate-700 border-slate-200",
  REMOVED_BY_POSTER: "bg-amber-100 text-amber-900 border-amber-200",
  REMOVED_BY_TEEN: "bg-amber-100 text-amber-900 border-amber-200",
  CANCELLED: "bg-slate-100 text-slate-700 border-slate-200",
};

export const guardianStatusPillClassName: Record<GuardianRelationshipStatus, string> = {
  ACTIVE: "bg-emerald-100 text-emerald-900 border-emerald-200",
  PENDING: "bg-amber-100 text-amber-900 border-amber-200",
  REMOVED: "bg-slate-100 text-slate-700 border-slate-200",
};

export const toReadableDateTime = (value: string | null): string => {
  return formatShortDateTime(value, "TBD");
};

export const toReadableGigDateTime = (value: string | null, timeZone?: string | null): string => {
  return formatShortDateTimeInGigTimeZone(value, timeZone, "TBD");
};

export const toReadableDate = (value: string | null): string => {
  return formatDate(value, "TBD");
};

export const toCurrency = (cents: number | null, volunteer: boolean): string => {
  return formatTeenGigCompensation(cents, volunteer);
};
